import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/ClaimMerkleDetails';

export const TRACK_MERKLE_VIZ_NODE_CLICK = `${prefix}/TRACK_MERKLE_VIZ_NODE_CLICK`;

export const FETCH_MERKLE_DETAILS_FOR_CLAIM = defineAsyncActionTypes(
  `${prefix}/FETCH_MERKLE_DETAILS_FOR_CLAIM`
);



// WEBPACK FOOTER //
// ./src/store/graphql/ClaimMerkleDetails/action-types.js